export const progressConstants = {
    ADD_ITEMS: "ADD_ITEMS",
    REMOVE_ITEM_BY_CONDITION: "REMOVE_ITEM_BY_CONDITION",
    REMOVE_ITEM_BY_SOCKETTYPE: "REMOVE_ITEM_BY_SOCKETTYPE",
    REMOVE_ALL: "REMOVE_ALL",
    SPLASH_COMPLETE: "SPLASH_COMPLETE",
};
